<script>
/* COMPOSANTS */
/* MIXINS */

export default {
  components: {},
  mixins: [],
  props: {
    description: {type: String},
    icon: {type: Boolean, default: true},
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>
<template>
  <div class="flex p-3 bg-secondary-50 rounded-md gap-2 items-start">
    <img v-if="icon" src="@refonte/icons/information.svg" />
    <slot name="icon" />
    <span class="text-primary font-medium text-sm text-wrap" v-if="this.description" v-html="this.description" />
  </div>
</template>
